import React from 'react';
import { formatCurrency, formatProjectionDate } from 'utils/formatting';

interface IPoint {
  x: number;
  y: number;
}

interface ISeries {
  name: string;
}

interface IProjectionTooltipProps {
  point: IPoint;
  series: ISeries;
  currency?: string;
  t?: (key: string, options?: Record<string, any>) => string;
  getAmountWithDecimals?: (amount: number, currency?: string) => string | number;
}

const ProjectionTooltip = ({
    point: {
        x,
        y,
    },
    series: { name },
    currency = '',
    t = (str) => str,
    getAmountWithDecimals,
}: IProjectionTooltipProps) => (
    <div>
        <div className="tooltip-row">
            {name}
            :
            <span className="value">
                {getAmountWithDecimals
                    ? getAmountWithDecimals(y, currency)
                    : formatCurrency(y, currency)}
            </span>
        </div>
        <div className="tooltip-row">
            {formatProjectionDate(x, t)}
        </div>
    </div>
);

export default ProjectionTooltip;
